import type { DCSession } from '@/auth';
import { Session } from 'next-auth';

export const getRoles = (session: Session | null): string[] => {
  if (session) {
    const customSession = session as unknown as DCSession;
    if (Array.isArray(customSession.roles) && customSession.roles.length > 0) {
      return customSession.roles;
    }
  }
  return [];
};

export const isAdmin = (session: Session | null): boolean => {
  return getRoles(session).includes('admin');
};

export const isSupport = (session: Session | null): boolean => {
  return getRoles(session).includes('supporter');
};

export const isSupportOrAdmin = (session: Session | null): boolean => {
  return isSupport(session) || isAdmin(session);
};

export const getAccessToken = (session: Session | null): string => {
  if (sessionUsable(session)) {
    const customSession = session as unknown as DCSession;
    return customSession.accessToken;
  }
  return '';
};

export const sessionUsable = (session: Session | null): boolean => {
  if (!session) {
    return false;
  }
  const dcSession = session as unknown as DCSession;
  return (
    !dcSession.accessTokenExpires || dcSession.accessTokenExpires > Date.now()
  );
};

export const canEditGroup = (
  session: DCSession | null,
  memberships: { user: { userId: number }; role: string }[],
) => {
  return !!(
    isAdmin(session) ||
    isSupportOrAdmin(session) ||
    (session &&
      memberships.some(
        (m) => m.user.userId === session.userId && m.role === 'Responsible',
      ))
  );
};

export const canManageGroup = (
  session: DCSession | null,
  memberships: { user: { userId: number }; role: string }[],
) => {
  return (
    isAdmin(session) ||
    isSupportOrAdmin(session) ||
    (session &&
      memberships.some(
        (m) =>
          m.user.userId === session.userId &&
          (m.role === 'Responsible' || m.role === 'Member'),
      ))
  );
};
